import { render, staticRenderFns } from "./smartLinkBigScreen.vue?vue&type=template&id=886ca436&scoped=true"
import script from "./smartLinkBigScreen.vue?vue&type=script&lang=js"
export * from "./smartLinkBigScreen.vue?vue&type=script&lang=js"
import style0 from "./smartLinkBigScreen.vue?vue&type=style&index=0&id=886ca436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886ca436",
  null
  
)

export default component.exports